import qs from 'qs';
import queryString from 'query-string';
import { uploadFileToObs } from '@meitu/saas-editor-core/es/utils/upload-kit';
import request, { extend } from '@meitu/saas-editor-ui/es/request';
import { initConfig as initAiAPIConfig } from '@meitu/x-design-ai-api';
import { REACT_APP_GENERATE_PIC_API_HOST, REACT_APP_POSTER_API_ORIGIN } from '@/react-process-env';
import { DEFAULT_LANGUAGE, NEED_NEW_CLIENT_ID_URL } from '@/types';
import { getAccessToken, getClientId } from '@/utils/auth';
import { isBetaEnv, isDevelopEnv, isReleaseEnv } from './env';
import { getQueryParam } from './query';

/** 获取json数据 */
export const getJSONByUrl = async (url: string) => {
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error('网络响应失败');
    }
    return response.json(); // 将响应解析为 JSON
};

export const getGeneratePictureUrl = () => {
    return REACT_APP_GENERATE_PIC_API_HOST;
};

export const getWsHostname = (protocol = 'https') => {
    const url = {
        pre: `${protocol}://prewebsocket-design.meitu.com`,
        // beta: `${protocol}://betawebsocket-design.meitu.com`,
        beta: `${protocol}://websocket-design.meitu.com`,
        release: `${protocol}://websocket-design.meitu.com`,
    };

    if (isDevelopEnv()) {
        return url.pre;
    } else {
        return getEnvApi(url);
    }
};

const getEnvApi = (apiMap: { [key: string]: string }, noBeta = false) => {
    const beta = noBeta ? 'release' : 'beta';
    const env = isReleaseEnv() ? 'release' : isBetaEnv() ? beta : 'pre';
    return apiMap[env];
};

export const getWebApiHostname = (env = 'pre') => {
    const url: any = {
        pre: 'https://prewebapi-pc.meitu.com',
        beta: 'https://betawebapi-pc.meitu.com',
        release: 'https://webapi-pc.meitu.com',
    };
    console.log('dev', env, url[env]);
    if (isDevelopEnv()) {
        console.log('dev', env, url[env]);
        return url[env];
    } else {
        return getEnvApi(url);
    }
};

export const getTextTemplateWebApiHostName = (env = 'pre') => {
    const url: any = {
        pre: 'https://preapi-mcptool.meitu.com',
        beta: 'https://betaapi-mcptool.meitu.com',
        release: 'https://api-mcptool.meitu.com',
    };
    console.log('dev', env, url[env]);
    if (isDevelopEnv()) {
        console.log('dev', env, url[env]);
        return url[env];
    } else {
        return getEnvApi(url);
    }
};

export const getWebSiteHostname = (env = 'pre') => {
    const url: any = {
        pre: 'https://prewebapi.designkit.com',
        beta: 'https://betawebapi.designkit.com',
        release: 'https://webapi.designkit.com',
    };
    console.log('dev', env, url[env]);
    if (isDevelopEnv()) {
        console.log('dev', env, url[env]);
        return url[env];
    } else {
        return getEnvApi(url);
    }
};

// 在入口文件app.tx/index.tx配置
const BASE_URL = REACT_APP_POSTER_API_ORIGIN;

// 接口公共参数
export const getCommonParams = () => {
    return {
        client_id: getClientId(),
        client_language: DEFAULT_LANGUAGE,
        language: DEFAULT_LANGUAGE,
    };
};

// 成本分摊埋点公共参数
const getMtccCommonParams = async () => {
    return {} as any;
};

extend({
    baseURL: BASE_URL,
    config: {
        adaptor: (res) => {
            return {
                // 状态码，0-成功，非0-错误
                error_code: (res as any)?.data?.error_code,
                // 错误信息
                msg: (res as any)?.data?.msg,
                // 数据
                data: (res as any)?.data?.data,
            };
        },
        // 成功状态code
        successCode: 0,
        // 未登录态code
        unauthorizedCodes: [401],
        // 全局请求异常处理函数
        errorHandler: () => {},
    },
    requestInterceptors: [
        (config: any) => {
            let preview_mode = 1;
            // 在发送请求之前做些什么
            // if (!gid && isUserMode()) {
            //     await getDeviceId();
            // }
            const isIntl = getQueryParam('isIntl') === '1';
            const needClientID = NEED_NEW_CLIENT_ID_URL.some((item) => (config.url || '').includes(item)) && isIntl;
            if (process.env.REACT_APP_ENV === 'release') {
                preview_mode = 0;
            } else {
                const params = queryString.parse(window.location.search);
                if (params && params.debug && params.preview) {
                    preview_mode = +params.preview;
                }
            }
            if (config.method === 'post') {
                const data = Object.assign(
                    {},
                    getCommonParams(),
                    // { gid },
                    { preview_mode },
                    config.data || {},
                    needClientID
                        ? {
                              client_id: '1189857628',
                          }
                        : {},
                );

                if (!config.headers['Content-Type']) {
                    config.data = qs.stringify(data);
                    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                }
            } else if (config.method === 'get') {
                config.params = Object.assign(
                    {
                        timestamp: new Date().getTime(),
                    },
                    // { gid },
                    { preview_mode },
                    getCommonParams(),
                    config.params || {},
                    needClientID
                        ? {
                              client_id: '1189857628',
                          }
                        : {},
                );
            }
            if (['/user/checkLogin', '/user/logout'].includes(config.url as string)) {
                config.baseURL = isDevelopEnv()
                    ? process.env.REACT_APP_USER_API_OFFICE_LOCAL
                    : process.env.REACT_APP_USER_API_OFFICE;
            }

            // 登录凭证
            config.headers['access-token'] = getAccessToken(); // 登录凭证

            if (config.url.indexOf('/image/api') !== -1) {
                config.baseURL = isDevelopEnv()
                    ? process.env.REACT_APP_IMAGE_EDITOR_LOCAL
                    : process.env.REACT_APP_IMAGE_EDITOR;
            }

            if (config.url.indexOf('/user/maat') !== -1) {
                config.baseURL = isDevelopEnv()
                    ? process.env.REACT_APP_USER_API_MAAT_LOCAL
                    : process.env.REACT_APP_USER_API_MAAT;
            }
            if (config.url.indexOf('/upload/policy') !== -1) {
                config.headers['Access-Token'] = getAccessToken();
                config.headers['File-Key'] = config?.params?.file || '';
                config.params = {
                    app: config.params.app,
                    type: config.params.type,
                    count: config.params.count,
                    sig: config.params.sig,
                    sigTime: config.params.sigTime,
                    suffix: config.params.suffix,
                };
                delete config.params.file;
                config.baseURL = isDevelopEnv()
                    ? process.env.REACT_APP_USER_API_POLICY_LOCAL
                    : process.env.REACT_APP_USER_API_POLICY;
            }
            return config;
        },
    ],
    responseInterceptors: [],
});

/** 全局统一配置 AI API 的接口*/
initAiAPIConfig({
    requestOptions: {
        baseURL: getWebApiHostname(),
    },
    request,
    uploadFileToObs,
    getMtccCommonParams,
});
